import { html } from "lit";
var icon_shapes_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(4 4)"
      stroke-width="2"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round">
      <rect width="9.6" height="9.6" rx="1.33" />
      <circle cx="19.2" cy="4.8" r="4.8" />
      <path
        d="M19.24 14.1a.95.95 0 0 0-1.68 0l-4.62 8.34a1.1 1.1 0 0 0-.01 1.04c.16.31.49.52.84.52h9.26c.35 0 .68-.2.84-.52a1.1 1.1 0 0 0 0-1.04l-4.63-8.33Z" />
      <path
        d="M5.44 13.1a.83.83 0 0 0-1.28 0L.2 17.84a.88.88 0 0 0 0 1.12l3.96 4.74a.83.83 0 0 0 1.28 0l3.95-4.74a.88.88 0 0 0 0-1.12L5.44 13.1Z" />
    </g>
  </svg>
`;
export {
  icon_shapes_default as default
};
//# sourceMappingURL=icon-shapes.js.map
